import React, { useEffect } from "react";

// Import your components
import Getapp from "./Getapp";
import Toptobottom from "./Toptobottom";
import Appinformation from "./Appinformation";
import Ourclints from "./Ourclints";
import Faqs from "./Faqs";
import Homegeleery from "./Homegeleery";
import Footer from "./Footer";
import MainBanner from "./MainBanner";
import Auth from "../Authentication/Auth";
const Login = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ backgroundColor: "white", overflowY: "auto", height: "100vh" }}>

      <Auth />
      <Homegeleery />
      <Ourclints />
      <Getapp />
      <Faqs />
      <Appinformation />

      <Toptobottom />
      <Footer />
    </div>
  );
};

export default Login;
